import { ValidNickname } from '@/lib/validations'
import { usePartnerPageDataStore } from '@/store/store'
import { Button, CircularProgress, Dialog, TextField, Typography } from '@mui/material'
import { PROFILE_SERVICE_ERRORS } from 'api/constants'
import { useAuth } from 'context/JWTContext'
import { useUpdateProfile } from 'hooks/useUpdateProfile'
import React from 'react'
import { toast } from 'react-hot-toast'

interface ChangeNicknameModalProps {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export function ChangeNicknameModal({ isOpen, setIsOpen }: ChangeNicknameModalProps) {
  const { reloadUser } = useAuth()
  const [nickname, setNickname] = React.useState<string>('')
  const validatedNickname = ValidNickname.safeParse(nickname)
  const { mutate, isLoading } = useUpdateProfile({ nickname })
  const [page] = usePartnerPageDataStore((state) => [state.partnerPageData])
  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault()
    mutate(undefined, {
      onSuccess: () => {
        reloadUser()
        toast.success('Name has been updated successfully', {
          position: 'top-center',
          style: { background: '#00BFA6', color: '#fff' },
        })
        setIsOpen(false)
      },
      onError: (e: any) =>
        toast.error(
          PROFILE_SERVICE_ERRORS[e.response.data.detail as keyof typeof PROFILE_SERVICE_ERRORS],
        ) as unknown as void,
    })
  }
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setNickname(value)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} maxWidth="sm">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: '10px',
        }}
      >
        <Typography
          style={{
            margin: '10px',
            fontFamily: page?.fonts.secondary_font.family,
            color: page?.base_game_text_color,
          }}
        >
          Change Name
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            onChange={handleChange}
            value={nickname}
            variant="outlined"
            error={!validatedNickname.success && nickname.length > 0}
            helperText={
              !validatedNickname.success && nickname.length > 0
                ? validatedNickname?.error.errors[0].message
                : null
            }
            sx={{ margin: '20px', width: '250px' }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button variant="contained" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={isLoading || !validatedNickname.success}
              sx={{
                backgroundColor: page?.primary_button_color,
                color: page?.primary_button_text_color,
              }}
            >
              {isLoading ? <CircularProgress size={20} /> : 'Ok'}
            </Button>
          </div>
        </form>
      </div>
    </Dialog>
  )
}
